import Button from "react-bootstrap/Button";
import React, { useState, useEffect } from "react";

import PostData from './Languages/Lang/siteText.json'



import "aos/dist/aos.css";

import "./Recrutation/Recrutation.css";
import MoreLight from "./Recrutation/MoreLight";

import PL_description from './Languages/recrLang/PL_description.json';
import PL_requirements from './Languages/recrLang/PL_requirements.json';
import PL_offer from './Languages/recrLang/PL_offer.json';

import ENG_description from './Languages/recrLang/ENG_description.json';
import ENG_requirements from './Languages/recrLang/ENG_requirements.json';
import ENG_offer from './Languages/recrLang/ENG_offer.json';

import GER_description from './Languages/recrLang/GER_description.json';
import GER_requirements from './Languages/recrLang/GER_requirements.json';
import GER_offer from './Languages/recrLang/GER_offer.json';




const RecrutationLight = (props) => {


  const [state, setState] = useState(false);
  const [description, setDescription] = useState(false);
  const language = props.lang

  const triggerState = () => {
    setState(!state);
  };

  const toggleDescription = () => {
    setDescription("Description");
  };

  const toggleRequirements = () => {
    setDescription("Requirements");
  };
  const toggleOffer = () => {
    setDescription("Offer");
  };



  return (
    <div className="w-100 mt-5 h-100 Recrutation">
        <div className="col-12 col-lg-6 mx-auto">
        <h1 id='Position' className="display-3">
          {language === 'PL' && <>Rekrutacja</>}
          {language === 'ENG' && <>Recrutation</>}
          {language === 'GER' && <>Rekrutierung</>}
        </h1>
        </div>
        <div className='description mx-0 px-0'>
        {state === true && description === 'Description' && language === 'PL' && <MoreLight title='Opis Stanowiska' list={PL_description.map((postDetail, index) => {return <li>{postDetail}</li>})} />}
        {state === true && description === 'Requirements' && language === 'PL' &&  <MoreLight title='Wymagania' list={PL_requirements.map((postDetail, index) => {return <li>{postDetail}</li>})} />}
        {state === true && description === 'Offer' && language === 'PL' &&  <MoreLight title='Co oferujemy' list={PL_offer.map((postDetail, index) => {return <li>{postDetail}</li>})} />}

        {state === true && description === 'Description' && language === 'ENG' && <MoreLight title='Job description' list={ENG_description.map((postDetail, index) => {return <li>{postDetail}</li>})} />}
        {state === true && description === 'Requirements' && language === 'ENG' &&  <MoreLight title='Requirements' list={ENG_requirements.map((postDetail, index) => {return <li>{postDetail}</li>})} />}
        {state === true && description === 'Offer' && language === 'ENG' &&  <MoreLight title='What do we offer?' list={ENG_offer.map((postDetail, index) => {return <li>{postDetail}</li>})} />}

        {state === true && description === 'Description' && language === 'GER' && <MoreLight title='Stellenbeschreibung' list={GER_description.map((postDetail, index) => {return <li>{postDetail}</li>})} />}
        {state === true && description === 'Requirements' && language === 'GER' &&  <MoreLight title='Anforderungen' list={GER_requirements.map((postDetail, index) => {return <li>{postDetail}</li>})} />}
        {state === true && description === 'Offer' && language === 'GER' &&  <MoreLight title='Unser Angebot' list={GER_offer.map((postDetail, index) => {return <li>{postDetail}</li>})} />}
        </div>

        <div className="row h-100 mx-auto">
          {state === false && language !== "ESP" &&
          <div  data-aos='flip-up' className='col-12 col-xl-5 mx-auto'>

            {language === "PL" && PostData.map((postDetail, index) => {return<h3 className='creative text-3f4448'>{postDetail.recrutation1short}</h3>})}
            {language === "ENG" && PostData.map((postDetail, index) => {return<h3 className='creative text-3f4448'>{postDetail.recrutation1shortENG}</h3>})}
            {language === "GER" && PostData.map((postDetail, index) => {return<h3 className='creative text-3f4448'>{postDetail.recrutation1shortGER}</h3>})}

            <Button onClick={triggerState} block variant='danger' className='mx-auto'>

            {language === "PL" && PostData.map((postDetail, index) => {return<h1 className='speditor'>{postDetail.recrutation1job}</h1>})}
            {language === "ENG" && PostData.map((postDetail, index) => {return<h1 className='speditor'>{postDetail.recrutation1jobENG}</h1>})}
            {language === "GER" && PostData.map((postDetail, index) => {return<h1 className='speditor'>{postDetail.recrutation1jobGER}</h1>})}

            {language === "PL" && PostData.map((postDetail, index) => {return<small className='text-warning'>{postDetail.recrutation1more}</small>})}
            {language === "ENG" && PostData.map((postDetail, index) => {return<small className='text-warning'>{postDetail.recrutation1moreENG}</small>})}
            {language === "GER" && PostData.map((postDetail, index) => {return<small className='text-warning'>{postDetail.recrutation1moreGER}</small>})}


              </Button>
          </div>}

          {state === true && (
            <div data-aos='flip-down' className='col-12 p-0 col-xl-6 mx-auto'>
              <div className="w-100 Recrutation-button-group row mx-auto">
                <div className="col-12 col-xl-4 mx-0 px-0">
                  <Button
                    href='#Position'
                    onClick={toggleDescription}
                    block
                    className="Recrutation-button"
                    variant="outline-dark"
                  >
                    {language === "PL" && PostData.map((postDetail, index) => {return<h3 className='creative'>{postDetail.recrutation2description}</h3>})}
                    {language === "ENG" && PostData.map((postDetail, index) => {return<h3 className='creative'>{postDetail.recrutation2descriptionENG}</h3>})}
                    {language === "GER" && PostData.map((postDetail, index) => {return<h3 className='creative'>{postDetail.recrutation2descriptionGER}</h3>})}
                  </Button>
                </div>{" "}
                <div className="col-12 col-xl-4 mx-0 px-0">
                  <Button
                  href='#Position'
                    onClick={toggleRequirements}
                    block
                    className="Recrutation-button"
                    variant="outline-dark"
                  >
                    {language === "PL" && PostData.map((postDetail, index) => {return<h3 className='creative'>{postDetail.recrutation2requirements}</h3>})}
                    {language === "ENG" && PostData.map((postDetail, index) => {return<h3 className='creative'>{postDetail.recrutation2requirementsENG}</h3>})}
                    {language === "GER" && PostData.map((postDetail, index) => {return<h3 className='creative'>{postDetail.recrutation2requirementsGER}</h3>})}
                  </Button>
                </div>{" "}
                <div className="col-12 col-xl-4 mx-0 px-0">
                  <Button
                    href='#Position'
                    onClick={toggleOffer}
                    block
                    className="Recrutation-button"
                    variant="outline-dark"
                  >
                    {language === "PL" && PostData.map((postDetail, index) => {return<h3 className='creative'>{postDetail.recrutation2offer}</h3>})}
                    {language === "ENG" && PostData.map((postDetail, index) => {return<h3 className='creative'>{postDetail.recrutation2offerENG}</h3>})}
                    {language === "GER" && PostData.map((postDetail, index) => {return<h3 className='creative'>{postDetail.recrutation2offerGER}</h3>})}
                  </Button>
                </div>
              </div>
            <Button onClick={triggerState} block variant='danger' className='mx-auto'>
            {language === "PL" && PostData.map((postDetail, index) => {return<h1 className='speditor'>{postDetail.recrutation2job}</h1>})}
            {language === "ENG" && PostData.map((postDetail, index) => {return<h1 className='speditor'>{postDetail.recrutation2jobENG}</h1>})}
            {language === "GER" && PostData.map((postDetail, index) => {return<h1 className='speditor'>{postDetail.recrutation2jobGER}</h1>})}

            {language === "PL" && PostData.map((postDetail, index) => {return<small className='text-warning'>{postDetail.recrutation2more}</small>})}
            {language === "ENG" && PostData.map((postDetail, index) => {return<small className='text-warning'>{postDetail.recrutation2moreENG}</small>})}
            {language === "GER" && PostData.map((postDetail, index) => {return<small className='text-warning'>{postDetail.recrutation2moreGER}</small>})}

            </Button>
          </div>
          )}
          
        </div>
    </div>
  );
};

export default RecrutationLight;
